import { Logger } from '@hawtiosrc/core/logging'

export const pluginId = 'connect'
export const statusPluginId = 'connectStatus'
export const pluginTitle = 'Connect'
export const pluginPath = '/connect'
export const pluginName = 'hawtio-connect'
export const log = Logger.get(pluginName)

export const PATH_PROXY_ENABLED = 'proxy/enabled'
